<!--
 * @Author: cryi.liu
 * @Date: 2020-05-07 14:37:00
 * @LastEditTime: 2020-09-15 16:08:13
 * @Description: 试题库筛选条件
 -->
<template>
  <div class="library-filter">
    <i-checkbox
      class="title"
      :indeterminate="indeterminate"
      :value="checkAll" @click.prevent.native="selectAllOrCanelAll">所属题库</i-checkbox>
    <i-checkbox-group v-model="typesFilter" @on-change="checkGroupChanged">
      <i-checkbox
        v-for="type in libraryTypes"
        :key="type"
        :label="type" />
    </i-checkbox-group>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

export default {
  name: 'LibraryFilter',
  props: {
    libraryTypes: { type: Array, required: true },
  },
  data() {
    return {
      indeterminate: false,
      checkAll: false,
      typesFilter: [],
    };
  },
  computed: {
    ...mapGetters({
      filters: 'libraryStore/filters',
    }),
    typesFilterStore() {
      return this.$store.state.libraryStore.filters.types;
    },
  },
  watch: {
    typesFilter(types) {
      this.setTypesFilter({ types });
    },
    typesFilterStore(types) {
      this.typesFilter = types;

      if (types.length === 0) {
        this.checkAll = false;
        this.indeterminate = false;
      }
    },
  },
  methods: {
    ...mapActions({
      setTypesFilter: 'libraryStore/invokeSetTypesFilter',
    }),
    /**
     * 题库类型筛选全选与取消全选
     */
    selectAllOrCanelAll() {
      if (this.indeterminate) {
        this.checkAll = false;
      } else {
        this.checkAll = !this.checkAll;
      }
      this.indeterminate = false;

      this.typesFilter = [];
      if (this.checkAll) {
        this.libraryTypes.forEach((type, index) => {
          this.$set(this.typesFilter, index, type);
        });
      }
    },
    /**
     * 题库类型复选框组变化
     */
    checkGroupChanged(data) {
      if (data.length === this.libraryTypes.length) {
        this.indeterminate = false;
        this.checkAll = true;
      } else if (data.length > 0) {
        this.indeterminate = true;
        this.checkAll = false;
      } else {
        this.indeterminate = false;
        this.checkAll = false;
      }
    },
  },
};
</script>

<style lang="less" scoped>
.library-filter {
  position: relative;
  width: 100%;

  > .title {
    margin-bottom: 12px;
    font-size: 13px;

    /deep/ .ivu-checkbox {
      margin-right: 6px;
    }
  }

  /deep/ .ivu-checkbox-group {
    padding-left: 26px;

    .ivu-checkbox-group-item {
      font-size: 13px;

      .ivu-checkbox {
        margin-right: 6px;
      }
    }
  }

  .model-filter {
    display: flex;
    align-items: center;
    padding-left: 26px;
    padding-top: 12px;

    .model-list {
      display: none;

      &.show {
        display: block;
      }
    }

    /deep/ .ivu-checkbox-group {
      padding-left: 0;
    }

    /deep/ .ivu-checkbox-wrapper {
      height: 18px;
      font-size: 13px;

      .ivu-checkbox {
        margin-right: 6px;
      }
    }
  }
}
</style>
